import React, { useState, useEffect, useRef} from 'react';
import {useHistory} from "react-router-dom";
import {v1 as uuid} from 'uuid'
import dienste from './dienste'



const delay = millis => new Promise((resolve, reject) => {
    setTimeout(_ => resolve(), millis)
  });

const useBarcode=(props)=>
{
    const {paketDienst,videoRef,barcodeActive,scanningStep,setScanningStep,paketeDB,shopDB, checkCode,mapCodes, setMediaStream} =props
 // Scan Barcode

    const detectorBarcode = useRef()
    const codeError=useRef(0)
    const detectorError=useRef(0)
    const [barcodeDetected, setBarcodeDetected]= useState(true)
    const [actPaket,setActPaket]=useState()
    const shopPraefix=useRef('')
    const shopNextCode=useRef(1000)
    const history= useHistory()
    const [count,setCount]=useState(0)

  

    if(barcodeActive.current && scanningStep!=='ocr' && ! detectorBarcode.current)
    {
        const codeType= dienste[paketDienst].codeTypes
        detectorBarcode.current=new window.BarcodeDetector({ formats: codeType
        /*[
        'aztec',
        'code_128',
        'code_39',
        'code_93',
        'codabar',
        'data_matrix',
        'ean_13',
        'ean_8',
        'itf',
        'pdf417',
        'qr_code',
        'upc_a',
        'upc_e'
        ]*/
      })
    }
    else if(barcodeActive.current && scanningStep!=='barcode-request' && scanningStep!=='barcode')
    {
        detectorBarcode.current=null
        barcodeActive.current=false

    }

    const checkCodeShop = (code)=>
    {
        const regex=new RegExp('^'+shopPraefix.current+'[0-9]{4,}')
        if( regex.test(code) )
            return true
        else
         return false

    }

    const createPaketCode=(code)=>
    {
        const id=uuid()
        window.navigator.vibrate([400]);        
        codeError.current=0
        const myPaket= {
            UID:id,
            Kunde:'',
            Dienst:paketDienst,
            Datum:Date.now()/1000,
            AbsenderK:'',
            ScanRaw:code.raw,
            Paketnummer:code.code,
            Status:'zugeordnet',

        }
        paketeDB.add(myPaket)
        setActPaket(myPaket.UID)
        barcodeActive.current=false
        setScanningStep('ocr-request')
        setMediaStream(null)
        detectorBarcode.current=null
    }


    const newPaketFromCode=async (codes)=>
    {
        // shop codes haben vorrang
        let myCodes= codes.filter(el=>(checkCodeShop(el))).map(el=>({code:el, raw:el}))
        if(myCodes.length===0)
        {
            // filter for valid codes
            myCodes=codes.map(el=>({raw: el, code:dienste[paketDienst].codeProcess(el)})).filter(el=>(checkCode((el.raw))))
        }
        else
        {
            myCodes= [myCodes[0]]
        }
        //remove potential duplicates
        const filteredUniqueCodes=myCodes.filter((item,index)=> (myCodes.findIndex(el=>el.code===item.code)===index))
        if( filteredUniqueCodes.length===1 )
        {
            createPaketCode(filteredUniqueCodes[0])
            if(mapCodes)
                alert(`Paket ist nicht auf der ${paketDienst} Liste und wurde neu angelegt`)
        }
        else
        {
            setCount((c)=>(c+1))
            ++codeError.current
        }
        
        if(codeError.current>20)
        {
            createPaketCode(shopPraefix + shopNextCode.parseInt() )

           
        }
   
 
    }
   
    useEffect(()=>
    {
        const scanBarcode = async ()=>
        { 
            if(!shopPraefix.current)
            {
                const shop= await shopDB.get('MyShop')
                if(shop)
                {
                    shopPraefix.current=shop.CodePraefix
                    shopNextCode.current=shop.NextCode
                }
            }
            try 
            {
                const codeReadings = await detectorBarcode.current.detect(videoRef.current);
                // remove ]C1 or %  from beginning 
                const codes=codeReadings.map(el=>el.rawValue)
                const codes2=codes.map(el=>(el.replace(/^]C1|^%/,'')))
                if(codes.length>0)
                {
                    detectorError.current=0
                    const myPaket=await paketeDB.where('ScanRaw').anyOf(codes).or('Paketnummer').anyOf(codes2).first() 
                    if(myPaket)
                    {
                
                        window.navigator.vibrate([400]);
                        barcodeActive.current=false
                        setActPaket(myPaket.UID)
                        detectorBarcode.current=null
                        codeError.current=0
                        if(myPaket.Status==='angemeldet')
                        {
                            if(!mapCodes)
                                alert('Paket ist schon angemeldet')
                            setScanningStep('ocr-request')

                            setMediaStream(null)
                        }
                        else
                        {
                           if(!mapCodes)
                                alert('Paket ist schon registriert')
                           setScanningStep('show-paket')
                           setMediaStream(null)
                        }


                
                    }
                    else if(paketDienst)
                    {

                        await newPaketFromCode(codes)
                    }
                }
                else
                {
                    setCount((c)=>(c+1))
                }
            }
            catch (e) 
            {
                console.error('Barcode detection failed:', e);
                ++detectorError.current
                if(detectorError.current<5)
                {
                    detectorBarcode.current=null
                    await delay(100)
                    detectorBarcode.current =  new window.BarcodeDetector({ formats: dienste[paketDienst].codeTypes
                        /*[
                        'aztec',
                        'code_128',
                        'code_39',
                        'code_93',
                        'codabar',
                        'data_matrix',
                        'ean_13',
                        'ean_8',
                        'itf',
                        'pdf417',
                        'qr_code',
                        'upc_a',
                        'upc_e'
                        ]*/
                    })
                    setCount((c)=>(c+1))
                }
                else
                {
                        alert('Barcodeerkennung fehlgeschlagen, Browser bitte neu starten')
                        detectorBarcode.current=null
                        barcodeActive.current=false
                        setMediaStream(null)
                        setScanningStep(null)
                }
            
            }
        }

      

        if(barcodeActive.current)
        {

                scanBarcode()

        
        }
            

    },[barcodeActive.current,scanningStep, count])
    return [actPaket,setActPaket]
}
export default useBarcode
